'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _button = require('../button');

var _button2 = _interopRequireDefault(_button);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultButtonState = {
  'error': { text: 'Error', type: 'danger', icon: 'exclamation-circle-o' },
  'saved': { text: 'Saved', type: 'success', icon: 'check-circle-o' },
  'unsaved': { text: 'Save', type: 'primary' },
  'saving': { text: 'Saving', type: 'primary', icon: 'circle-empty' }
};

var prepareForMerge = (0, _ramda.map)(function (value) {
  return { text: value };
});

var mergeWithText = (0, _ramda.pipe)(prepareForMerge, (0, _ramda.mergeWith)(_ramda.merge, defaultButtonState));

var clean = (0, _ramda.omit)(['saveStatus', 'customText']);

var enhance = (0, _recompose.compose)((0, _recompose.setDisplayName)('SaveButton'), (0, _recompose.setPropTypes)({
  saveStatus: _propTypes2.default.oneOf(['unsaved', 'saved', 'saving', 'error']).isRequired,
  onClick: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,

  customText: _propTypes2.default.shape({
    unsaved: _propTypes2.default.string,
    saved: _propTypes2.default.string,
    saving: _propTypes2.default.string,
    error: _propTypes2.default.string
  })
}), (0, _recompose.withProps)(function (_ref) {
  var _ref$customText = _ref.customText,
      customText = _ref$customText === undefined ? {} : _ref$customText,
      saveStatus = _ref.saveStatus;
  return {
    status: mergeWithText(customText)[saveStatus],
    iconClass: saveStatus === 'saving' ? _styles2.default.flashing : ''
  };
}));

exports.default = enhance(function (_ref2) {
  var status = _ref2.status,
      rest = _objectWithoutProperties(_ref2, ['status']);

  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      _button2.default,
      _extends({}, clean(rest), {
        type: status.type,
        icon: status.icon }),
      status.text
    )
  );
});